import { useTranslation } from 'react-i18next'

import { EyeIcon } from '@phosphor-icons/react'

import { transactionsAnalyticsStatsValues } from '@reveni-io/reveni-ui'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const TransactionsForReview = ({ transactionsForReview, onClick }) => {
  const { t } = useTranslation()
  const count = Number(transactionsForReview)
  const hasValue = count > 0

  return (
    <Statistic
      size="small"
      status={hasValue ? statisticStatuses.warning : statisticStatuses.default}
      Icon={EyeIcon}
      label={t('Transacciones por revisar')}
      showStatusIcon={hasValue}
      value={<AnimatedNumber target={count} format="decimal" />}
      onClick={() => onClick(transactionsAnalyticsStatsValues.forReview)}
    />
  )
}

export default TransactionsForReview
